import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { ItemLimitTimeRec } from 'src/app/common/item-limit-time-rec';
import { TableColumnDef } from 'src/app/common/table-column-def';
import { SettingLimitParamDialogComponent } from 'src/app/dialog/setting-limit-param-dialog/setting-limit-param-dialog.component';
import { TableItemDialogComponent } from 'src/app/dialog/table-item-dialog/table-item-dialog.component';
import { ReqItemViewSortDto } from 'src/app/request/req-item-search';
import { CommonService } from 'src/app/service/common.service';
import { HttpBasicService } from 'src/app/service/http-basic.service';
import { ItemSearchCondition } from '../item-select-condition/item-select-condition.component';
import { ItemLimitTimeSearchRec } from 'src/app/common/item-limit-time-search-rec';
import { MatSort, Sort } from '@angular/material/sort';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
  selector: 'app-item-list-limit-time-param',
  templateUrl: './item-list-limit-time-param.component.html',
  styleUrls: ['./item-list-limit-time-param.component.css']
})
export class ItemListLimitTimeParamComponent implements OnInit, OnDestroy {
  public requestOrigin;
  public recordCountItemList: number;
  public recordCountSettingList: number;
  public itemList: ItemLimitTimeSearchRec[] = [];
  public itemListOrigin: ItemLimitTimeSearchRec[] = [];
  public itemListDisplay = new MatTableDataSource<ItemLimitTimeSearchRec>([]);
  public settingList: ItemLimitTimeRec[] = [];
  public settingListOrigin: ItemLimitTimeRec[] = [];
  public settingListDisplay = new MatTableDataSource<ItemLimitTimeRec>([]);
  public tableWidth: any;
  public pagenatorMaxWidth: any;
  public displayColumnIds: string[];
  public displayColumnIdsLimit: string[];
  public isSave: boolean = false;
  public minDateBegin: Date;
  public minDateEnd: Date;
  private minZai1: number = this.commonService.config?.paramItemLimitMinZaiRange?.min;
  private minZai2: number = this.commonService.config?.paramItemLimitMinZaiRange?.max;
  private maxZai1: number = this.commonService.config?.paramItemLimitMaxZaiRange?.min;
  private maxZai2: number = this.commonService.config?.paramItemLimitMaxZaiRange?.max;
  private minStock1: number = this.commonService.config?.paramItemLimitMinStockDaysRange?.min;
  private minStock2: number = this.commonService.config?.paramItemLimitMinStockDaysRange?.max;
  private maxStock1: number = this.commonService.config?.paramItemLimitMaxStockDaysRange?.min;
  private maxStock2: number = this.commonService.config?.paramItemLimitMaxStockDaysRange?.max;
  public stickyColumnDefs: TableColumnDef[] = [
    { columnId: 'storeCdFv', header: "店舗", width: 90, align: "center" },
    { columnId: 'itemCdFv', header: '商品コード', width: 90, align: 'center' },
    { columnId: "itemNameFv", header: "商品名", width: 300, align: "left" },
  ];

  public stickyColumnDefsLimit: TableColumnDef[] = [
    { columnId: 'delete', header: "削除", width: 80, align: "center" },
    { columnId: 'storeCdFv', header: "店舗", width: 90, align: "left" },
    { columnId: 'itemCdFv', header: '商品コード', width: 90, align: 'center' },
    { columnId: "itemNameFv", header: "商品名", width: 300, align: "left" },
  ];

  public columnDefs: TableColumnDef[] = [
    { columnId: "standardFv", header: "規格", width: 80, align: "left" },
    { columnId: "convFactFv", header: "入数", width: 80, align: "center" },
    {
      columnId: 'orderNumCurrentFn',
      header: this.commonService?.config?.orderBaraDisplayFlag ? "発注(ロット)数" : "発注数",
      width: this.commonService?.config?.orderBaraDisplayFlag ? 80 : 40,
      align: "right"
    },
    { columnId: 'orderBaraNumCurrentFn', header: "発注数", width: 40, align: "right" },
    { columnId: "orderLotFn", header: "ロット", width: 35, align: "right", colspan: 1 },
    { columnId: 'orderBaraNumFn', header: "発注(バラ)", width: 55, align: "right" },
    { columnId: "orderBacklog", header: "入荷予定", width: 60, maxWidth: 40, align: "right", colspan: 1 },
    { columnId: 'stockNumCurrentFn', header: "在庫数", width: 40, align: "right" },
    { columnId: 'deliveryDate', header: "納品予定日", width: 80, align: "center" },
    { columnId: 'suppNameFv', header: "発注先", width: 200 },
    { columnId: 'orderStopFlagCurrentFv', header: "自動発注", width: 80, align: "center" },
    { columnId: 'rankFv', header: "ランク", width: 30, align: "center" },
    { columnId: 'minZaiCurrentFv', header: "最低陳列", width: 30, align: "right" },
    { columnId: 'maxZaiCurrentFv', header: "最大陳列", width: 60, align: "right" },
    { columnId: 'minStockDaysCurrentFv', header: "最低在庫日数", width: 80, align: "right" },
    { columnId: 'maxStockDaysCurrentFv', header: "最大在庫日数", width: 80, align: "right" },
    { columnId: "itemLocation", header: "棚", width: 60, maxWidth: 60, align: "left", colspan: 1 },
    { columnId: "itemClass", header: "区分", width: 40, align: "center", colspan: 1 },
    { columnId: "salesResult1", header: "販1", width: 20, align: "right", colspan: 1 },
    { columnId: "salesResult2", header: "販2", width: 20, align: "right", colspan: 1 },
    { columnId: "salesResult3", header: "販3", width: 20, align: "right", colspan: 1 },
    { columnId: "salesResult4", header: "販4", width: 20, align: "right", colspan: 1 },
    { columnId: "orderResult1", header: "発1", width: 20, align: "right", colspan: 1 },
    { columnId: "orderResult2", header: "発2", width: 20, align: "right", colspan: 1 },
    { columnId: "orderResult3", header: "発3", width: 20, align: "right", colspan: 1 },
    { columnId: "orderResult4", header: "発4", width: 20, align: "right", colspan: 1 },
    { columnId: 'ctg0Fv', header: this.commonService.literal.ctg0Name, width: 200 },
    { columnId: 'ctg1Fv', header: this.commonService.literal.ctg1Name, width: 200 },
    { columnId: 'ctg2Fv', header: this.commonService.literal.ctg2Name, width: 200 },
    { columnId: 'ctg3Fv', header: this.commonService.literal.ctg3Name, width: 200 }
  ];

  public columnDefsLimit: TableColumnDef[] = [
    { columnId: "standardFv", header: "規格", width: 80, align: "left" },
    { columnId: "convFactFv", header: "入数", width: 80, align: "center" },
    { columnId: 'startDateFd', header: "開始日", width: 100, align: "center" },
    { columnId: 'finishDateFd', header: "終了日", width: 100, align: "center" },
    { columnId: 'rankFv', header: "ランク", width: 30, align: "center" },
    { columnId: 'minZaiCurrentFv', header: "最低陳列", width: 60, align: "right" },
    { columnId: 'maxZaiCurrentFv', header: "最大陳列", width: 60, align: "right" },
    { columnId: 'minStockDaysCurrentFv', header: "最低在庫日数", width: 80, align: "right" },
    { columnId: 'maxStockDaysCurrentFv', header: "最大在庫日数", width: 80, align: "right" },
    { columnId: "itemLocation", header: "棚", width: 60, maxWidth: 60, align: "left", colspan: 1 },
    { columnId: "itemClass", header: "区分", width: 40, align: "center", colspan: 1 },
    { columnId: "salesResult1", header: "販1", width: 20, align: "right", colspan: 1 },
    { columnId: "salesResult2", header: "販2", width: 20, align: "right", colspan: 1 },
    { columnId: "salesResult3", header: "販3", width: 20, align: "right", colspan: 1 },
    { columnId: "salesResult4", header: "販4", width: 20, align: "right", colspan: 1 },
    { columnId: "orderResult1", header: "発1", width: 20, align: "right", colspan: 1 },
    { columnId: "orderResult2", header: "発2", width: 20, align: "right", colspan: 1 },
    { columnId: "orderResult3", header: "発3", width: 20, align: "right", colspan: 1 },
    { columnId: "orderResult4", header: "発4", width: 20, align: "right", colspan: 1 },
    { columnId: 'ctg0Fv', header: this.commonService.literal.ctg0Name, width: 200 },
    { columnId: 'ctg1Fv', header: this.commonService.literal.ctg1Name, width: 200 },
    { columnId: 'ctg2Fv', header: this.commonService.literal.ctg2Name, width: 200 },
    { columnId: 'ctg3Fv', header: this.commonService.literal.ctg3Name, width: 200 }
  ];
  public displayColumnDefs: TableColumnDef[] = [];
  public undisplayColumnDefs: TableColumnDef[] = [];

  public displayColumnDefsLimit: TableColumnDef[] = [];
  public undisplayColumnDefsLimit: TableColumnDef[] = [];

  private subscriptionSearch: Subscription;
  private subscriptionDialog: Subscription;
  public formGroupItem: FormGroup;

  @Input() itemSearchCondition: ItemSearchCondition;
  @Input() isOrderEditable: boolean = false;
  @Input() isStockEditable: boolean = false;
  @Input() isParamEditable: boolean = false;
  @Input() isOrderStopEditable: boolean = false;
  @Input() propColumns: string[];
  @ViewChild(MatTable, { static: true }) matTable: MatTable<any>;
  @ViewChild("matPagenator", { static: true }) matPagenator: MatPaginator;
  @ViewChild("matPagenatorLimit", { static: true }) matPagenatorLimit: MatPaginator;
  @ViewChild('orderListSort') orderListSort = new MatSort();
  @ViewChild('orderSetingSort') orderSetingSort = new MatSort();
  constructor(public commonService: CommonService,
    public httpBasic: HttpBasicService,
    private fb: FormBuilder,
    private dateAdapter: DateAdapter<any>,
    private _liveAnnouncer: LiveAnnouncer) { }

  ngOnInit() {
    this.matPagenator.length = 0;
    this.matPagenator.pageIndex = 0;
    this.matPagenatorLimit.length = 0;
    this.matPagenatorLimit.pageIndex = 0;
    let paramItemLimitStartday = this.commonService.config?.paramItemLimitStartday;
    let date = new Date();
    date.setDate(date.getDate() + paramItemLimitStartday)
    this.minDateBegin = paramItemLimitStartday ? date : new Date("2000/01/01");
    this.minDateEnd = this.minDateBegin;
    if (this.commonService.config?.itemEditOverMenus) {
      this.isOrderEditable = !this.commonService.checkPrivilegeNoRedirect("order");
      this.isStockEditable = !this.commonService.checkPrivilegeNoRedirect("stock");
      this.isParamEditable = !this.commonService.checkPrivilegeNoRedirect("itemparam");
      this.isOrderStopEditable = !this.commonService.checkPrivilegeNoRedirect("autotrgt");
    }
    for (var colDef of this.columnDefs) {
      if (this.propColumns && !this.propColumns.find((col) => colDef.columnId === col)) continue;
      if (colDef.columnId === "ctg0Fv" && this.commonService.config?.maxCtgLevel < 1) continue;
      if (colDef.columnId === "ctg1Fv" && this.commonService.config?.maxCtgLevel < 2) continue;
      if (colDef.columnId === "ctg2Fv" && this.commonService.config?.maxCtgLevel < 3) continue;
      if (colDef.columnId === "ctg3Fv" && this.commonService.config?.maxCtgLevel < 4) continue;

      if (colDef.columnId === "orderNumCurrentFn") colDef.editable = this.isOrderEditable;
      if (colDef.columnId === "stockNumCurrentFn") colDef.editable = this.isStockEditable;

      if (colDef.columnId === "minZaiCurrentFv" && this.isParamEditable) {
        colDef.editable = this.commonService.config?.paramItemLimitMinZaiEditable;
      }
      if (colDef.columnId === "maxZaiCurrentFv" && this.isParamEditable) {
        colDef.editable = this.commonService.config?.paramItemLimitMaxZaiEditable;
      }
      if (colDef.columnId === "minStockDaysCurrentFv" && this.isParamEditable) {
        colDef.editable = this.commonService.config?.paramItemLimitMinStockDaysEditable;
      }
      if (colDef.columnId === "maxStockDaysCurrentFv" && this.isParamEditable) {
        colDef.editable = this.commonService.config?.paramItemLimitMaxStockDaysEditable;
      }
      if (colDef.columnId === "orderStopFlagCurrentFv") colDef.editable = this.isOrderStopEditable;

      if (colDef.columnId !== "orderBaraNumCurrentFn" || this.commonService?.config?.orderBaraDisplayFlag) {
        this.displayColumnDefs.push(colDef);
      }
    }

    for (var colDef of this.columnDefsLimit) {
      if (this.propColumns && !this.propColumns.find((col) => colDef.columnId === col)) continue;
      if (colDef.columnId === "ctg0Fv" && this.commonService.config?.maxCtgLevel < 1) continue;
      if (colDef.columnId === "ctg1Fv" && this.commonService.config?.maxCtgLevel < 2) continue;
      if (colDef.columnId === "ctg2Fv" && this.commonService.config?.maxCtgLevel < 3) continue;
      if (colDef.columnId === "ctg3Fv" && this.commonService.config?.maxCtgLevel < 4) continue;

      if (colDef.columnId === "orderNumCurrentFn") colDef.editable = this.isOrderEditable;
      if (colDef.columnId === "stockNumCurrentFn") colDef.editable = this.isStockEditable;

      if (colDef.columnId === "minZaiCurrentFv" && this.isParamEditable) {
        colDef.editable = this.commonService.config?.paramItemMinZaiEditable;
      }
      if (colDef.columnId === "maxZaiCurrentFv" && this.isParamEditable) {
        colDef.editable = this.commonService.config?.paramItemMaxZaiEditable;
      }
      if (colDef.columnId === "minStockDaysCurrentFv" && this.isParamEditable) {
        colDef.editable = this.commonService.config?.paramItemMinStockDaysEditable;
      }
      if (colDef.columnId === "maxStockDaysCurrentFv" && this.isParamEditable) {
        colDef.editable = this.commonService.config?.paramItemMaxStockDaysEditable;
      }
      if (colDef.columnId === "orderStopFlagCurrentFv") colDef.editable = this.isOrderStopEditable;

      if (colDef.columnId !== "orderBaraNumCurrentFn" || this.commonService?.config?.orderBaraDisplayFlag) {
        this.displayColumnDefsLimit.push(colDef);
      }
    }

    if (this.propColumns) {
      // Sort propColumns order
      let tmp = this.displayColumnDefs;
      this.displayColumnDefs = [];
      this.propColumns.forEach((colId) => {
        let colDef = tmp.find((def) => def.columnId === colId);
        if (colDef) this.displayColumnDefs.push(colDef);
      });

      // Sort propColumns order
      let tmpLimit = this.displayColumnDefsLimit;
      this.displayColumnDefsLimit = [];
      this.propColumns.forEach((colId) => {
        let colDef = tmpLimit.find((def) => def.columnId === colId);
        if (colDef) this.displayColumnDefsLimit.push(colDef);
      });
    }

    this.formGroupItem = this.fb.group({
      dateBegin: ['', Validators.required],
      dateEnd: ['', Validators.required],
    });

    this.setColumnId();
    this.setColumnIdLimit();
    this.calcTableWidth();
  }

  ngOnDestroy() {
    if (this.subscriptionSearch) {
      this.subscriptionSearch.unsubscribe();
    }
    if (this.subscriptionDialog) {
      this.subscriptionDialog.unsubscribe();
    }
  }

  ngAfterViewInit() {
    this.sortData();
  }

  sortData() {
    this.itemListDisplay.sort = this.orderListSort;
    this.settingListDisplay.sort = this.orderSetingSort;
  }

  setColumnId() {
    this.displayColumnIds = [];

    for (var colDef of this.stickyColumnDefs) {
      this.displayColumnIds.push(colDef.columnId);
    }
    for (var colDef of this.displayColumnDefs) {
      if (colDef.columnId === "deliveryDate" && this.commonService.config?.deliveryDateColumn != true) {
        this.displayColumnDefs = this.displayColumnDefs.filter(column => column.columnId !== 'deliveryDate');
        continue;
      }
      this.displayColumnIds.push(colDef.columnId);
    }
  }

  setColumnIdLimit() {
    this.displayColumnIdsLimit = [];

    for (var colDef of this.stickyColumnDefsLimit) {
      this.displayColumnIdsLimit.push(colDef.columnId);
    }
    for (var colDef of this.displayColumnDefsLimit) {
      this.displayColumnIdsLimit.push(colDef.columnId);
    }
  }

  styleFor(id: string) {
    for (var colDef of this.columnDefs) {
      if (colDef.columnId === id) {
        return {
          "width": "" + colDef.width + "px",
          "text-align": colDef.align ? colDef.align : "left"
        }
      }
    }
  }

  styleForHeader(id: string) {
    for (var colDef of this.columnDefs) {
      if (colDef.columnId === id) {
        return {
          "width": "" + colDef.width + "px"
        }
      }
    }
  }

  calcTableWidth() {
    var width = 1;   // For left border
    for (var colDef of this.stickyColumnDefs) {
      width = width + colDef.width + 1 + 8;    // 1 for right border, 8 for padding
    }
    for (var colDef of this.displayColumnDefs) {
      if (colDef.columnId === "deliveryDate" && this.commonService.config?.deliveryDateColumn != true) {
        this.displayColumnDefs = this.displayColumnDefs.filter(column => column.columnId != 'deliveryDate');
        continue;
      }
      width = width + colDef.width + 1 + 8;    // 1 for right border, 8 for padding
    }
    this.tableWidth = { "width": "" + width + "px" };
    this.pagenatorMaxWidth = { "max-width": "" + width + "px" }
  }

  itemListPageChanged() {
    let start;
    let end;
    this.itemListDisplay.data = [];
    this.recordCountItemList = this.itemList?.length ?? 0;
    if (this.matPagenator) {
      start = this.matPagenator.pageIndex * this.matPagenator.pageSize
      end = start + this.matPagenator.pageSize;
    } else {
      start = 0;
      end = this.commonService.config?.pagenatorOptions[0];
    }
    if (end > this.recordCountItemList) end = this.recordCountItemList;
    if (this.itemListDisplay?.data.length == 1) return;
    else this.itemListDisplay.data = this.itemList?.slice(start, end);
  }

  settingListPageChanged() {
    let start;
    let end;
    this.settingListDisplay.data = [];
    this.recordCountSettingList = this.settingList?.length ?? 0;
    if (this.matPagenatorLimit) {
      start = this.matPagenatorLimit.pageIndex * this.matPagenatorLimit.pageSize
      end = start + this.matPagenatorLimit.pageSize;
    } else {
      start = 0;
      end = this.commonService.config?.pagenatorOptions[0];
    }
    if (end > this.recordCountSettingList) end = this.recordCountSettingList;
    if (this.settingListDisplay?.data.length == 1) return;
    else this.settingListDisplay.data = this.settingList?.slice(start, end);
  }

  // パラメータ欄はトモシア版と同じく、直接入力(サブ画面を開かない)とする
  // onClickCell(columnId: string, itemRec: ItemLimitTimeRec) {
  //   if (columnId === "orderNumCurrentFn" && this.isOrderEditable) {
  //     this.openOrderEditDialog(itemRec);
  //     return;
  //   }
  //   if (columnId === "stockNumCurrentFn" && this.isStockEditable) {
  //     this.openStockEditDialog(itemRec);
  //     return;
  //   }
  //   if (((columnId === "minZaiCurrentFv" && this.commonService.config?.paramItemMinZaiEditable) ||
  //     (columnId === "maxZaiCurrentFv" && this.commonService.config?.paramItemMaxZaiEditable) ||
  //     (columnId === "minStockDaysCurrentFv" && this.commonService.config?.paramItemMinStockDaysEditable) ||
  //     (columnId === "maxStockDaysCurrentFv" && this.commonService.config?.paramItemMaxStockDaysEditable)
  //   ) && this.isParamEditable) {
  //     this.openParamItemEditDialog(itemRec);
  //     return;
  //   }
  //   if (columnId === "orderStopFlagCurrentFv" && this.isOrderStopEditable) {
  //     this.openItemOrderStopEditDialog(itemRec);
  //     return;
  //   }
  // }

  // dialogResult(data: any) {
  //   this.subscriptionDialog.unsubscribe();
  //   this.subscriptionDialog = undefined;
  //   this.matTable.renderRows();
  // }

  // openOrderEditDialog(itemRec: ItemLimitTimeRec) {
  //   const dialogRef = this.commonService.dialog.open(OrderEditDialogComponent, {
  //     disableClose: true,
  //     data: itemRec,
  //     maxWidth: "95vw",
  //     position: { top: "5px" }
  //   });
  //   this.subscriptionDialog = dialogRef.afterClosed().subscribe(
  //     data => this.dialogResult(data)
  //   );
  // }

  // openStockEditDialog(itemRec: ItemLimitTimeRec) {
  //   const dialogRef = this.commonService.dialog.open(StockEditDialogComponent, {
  //     disableClose: true,
  //     data: itemRec,
  //     maxWidth: "95vw",
  //     position: { top: "5px" }
  //   });
  //   this.subscriptionDialog = dialogRef.afterClosed().subscribe(
  //     data => this.dialogResult(data)
  //   );
  // }

  // openParamItemEditDialog(itemRec: ItemLimitTimeRec) {
  //   const dialogRef = this.commonService.dialog.open(ParamItemEditDialogComponent, {
  //     disableClose: true,
  //     data: itemRec,
  //     maxWidth: "95vw",
  //     position: { top: "5px" }
  //   });
  //   this.subscriptionDialog = dialogRef.afterClosed().subscribe(
  //     data => this.dialogResult(data)
  //   );
  // }

  // openItemOrderStopEditDialog(itemRec: ItemLimitTimeRec) {
  //   const dialogRef = this.commonService.dialog.open(ItemOrderStopEditDialogComponent, {
  //     disableClose: true,
  //     data: itemRec,
  //     maxWidth: "95vw",
  //     position: { top: "5px" }
  //   });
  //   this.subscriptionDialog = dialogRef.afterClosed().subscribe(
  //     data => this.dialogResult(data)
  //   );
  // }

  genNewReqSaveDto(rec: ItemLimitTimeSearchRec) {
    var minZai = rec.minZaiCurrentFvForm.value;
    var maxZai = rec.maxZaiCurrentFvForm.value;
    var minStockDays = rec.minStockDaysCurrentFvForm.value;
    var maxStockDays = rec.maxStockDaysCurrentFvForm.value;
    let dateBegin = this.formGroupItem.get("dateBegin").value;
    let dateEnd = this.formGroupItem.get("dateEnd").value;
    let reqParamItemEdit = {
      storeCdFv: rec.storeCdFv,
      itemCdFv: rec.itemCdFv,
      minZai: minZai == '' ? '-1' : minZai,
      minZaiCurrentFv: rec.minZaiCurrentFv,
      maxZai: maxZai == '' ? '-1' : maxZai,
      maxZaiCurrentFv: rec.maxZaiCurrentFv,
      minStockDays: minStockDays == '' ? '-1' : minStockDays,
      minStockDaysCurrentFv: rec.minStockDaysCurrentFv,
      maxStockDays: maxStockDays == '' ? '-1' : maxStockDays,
      maxStockDaysCurrentFv: rec.maxStockDaysCurrentFv,
      dateBegin: dateBegin == '' ? '' : this.commonService.formatDate(dateBegin),
      dateEnd: dateEnd == '' ? '' : this.commonService.formatDate(dateEnd)
    }
    return reqParamItemEdit;
  }

  doSave() {
    let limitTimeParamEdit = this.itemList.map(rec => this.genNewReqSaveDto(rec)).filter(
      item => (item.minZai != item.minZaiCurrentFv)
        || (item.maxZai != item.maxZaiCurrentFv)
        || (item.minStockDays != item.minStockDaysCurrentFv)
        || (item.maxStockDays != item.maxStockDaysCurrentFv));

    let request = {
      access: this.commonService.loginUser,
      limitTimeParamEdit: limitTimeParamEdit,
      mode: "1"
    }

    this.commonService.openSpinner(this.commonService.pageTitle, "登録中・・・");
    let subsc = this.httpBasic.generalRequest("LimitTimeParamEdit", request).subscribe(
      (response) => {
        subsc.unsubscribe();
        this.commonService.closeSpinner();
        this.receiveSave(response, limitTimeParamEdit);
      },
      (error) => {
        subsc.unsubscribe();
        this.commonService.closeSpinner();
        this.httpBasic.handleError(error);
      }
    );
  }
  receiveSave(response, itemList) {
    if (this.httpBasic.handleAppError(response)) {
      return;
    }
    if (response.resultError?.length > 0) {
      const dialogRef = this.commonService.dialog.open(SettingLimitParamDialogComponent, {
        disableClose: true,
        data: {
          itemCheck: response.resultError,
          itemList: itemList,
          title: this.commonService.pageTitle
        }
      });
      let subsc = dialogRef.afterClosed().subscribe(
        (data) => {
          subsc.unsubscribe();
          if (!data) return;
          this.endEdit(data);
        }
      );
    }
    else this.doQueryBody(this.requestOrigin);
  }

  endEdit(data: any) {
    this.doQueryBody(this.requestOrigin);
  }

  paramToNumber(val: string) {
    return val === "" ? 0 : parseInt(val);
  }
  paramIsNull(val: string) {
    return val === "" ? true : false;
  }

  selectTableItem() {
    scrollTo(0, 0);
    const dialogRef = this.commonService.dialog.open(TableItemDialogComponent, {
      disableClose: true,
      data: { display: this.displayColumnDefs, nonDisplay: this.undisplayColumnDefs }
    });
    this.subscriptionDialog = dialogRef.afterClosed().subscribe(
      data => {
        this.setColumnId();
        this.calcTableWidth();
      }
    );
  }

  selectTableItemLimit() {
    scrollTo(0, 0);
    const dialogRef = this.commonService.dialog.open(TableItemDialogComponent, {
      disableClose: true,
      data: { display: this.displayColumnDefsLimit, nonDisplay: this.undisplayColumnDefsLimit }
    });
    this.subscriptionDialog = dialogRef.afterClosed().subscribe(
      data => {
        this.setColumnIdLimit();
        this.calcTableWidth();
      }
    );
  }

  doQuery(mode: number) {
    this.matPagenator.pageIndex = 0;
    this.matPagenatorLimit.pageIndex = 0;
    this.doQueryBody(mode);
  }

  doQueryBody(mode: number) {
    var itemSearchForm: FormGroup = this.itemSearchCondition.formGroup;
    var categorySearchCondition: FormGroup = this.itemSearchCondition.ctgSelectCondition.formGroup;
    var orderCurrentForm: FormGroup = itemSearchForm.get('orderCurrent') as FormGroup;
    var orderInitialForm: FormGroup = itemSearchForm.get('orderInitial') as FormGroup;
    var stockCurrentForm: FormGroup = itemSearchForm.get('stockCurrent') as FormGroup;
    var stockInitialForm: FormGroup = itemSearchForm.get('stockInitial') as FormGroup;
    var orderStopFlagForm: FormGroup = itemSearchForm.get('orderStopFlagFormGroup') as FormGroup;
    var itemViewSort: FormGroup = itemSearchForm.get('itemViewSort') as FormGroup;
    var dateBegin = itemSearchForm.get("dateBegin").value;
    var dateEnd = itemSearchForm.get("dateEnd").value;
    var request = {
      access: { ...this.commonService.loginUser },
      itemSearchCondition: {
        calcTrgtDateFd: this.dateAdapter.format(itemSearchForm.get('salesDate').value, null),
        storeCdFv: itemSearchForm.get('storeCd').value,
        ctgCd0Fv: categorySearchCondition.get('ctgLevel').value >= 0 ?
          categorySearchCondition.get('ctgCd0').value : "",
        ctgCd1Fv: categorySearchCondition.get('ctgLevel').value >= 1 ?
          categorySearchCondition.get('ctgCd1').value : "",
        ctgCd2Fv: categorySearchCondition.get('ctgLevel').value >= 2 ?
          categorySearchCondition.get('ctgCd2').value : "",
        ctgCd3Fv: categorySearchCondition.get('ctgLevel').value >= 3 ?
          categorySearchCondition.get('ctgCd3').value : "",
        rackCd1Fn: this.itemSearchCondition.rackSelectCondition.getCd1(),
        rackCd2Fn: this.itemSearchCondition.rackSelectCondition.getCd2(),
        rackCd3Fn: this.itemSearchCondition.rackSelectCondition.getCd3(),
        itemCdFv: itemSearchForm.get('itemCode').value.trim(),
        itemCdEqualSearch: false,
        itemNameFv: itemSearchForm.get('itemName').value.trim(),
        orderCurrentOperator: orderCurrentForm.get('isEnable').value ? orderCurrentForm.get('operatorType').value : 0,
        orderCurrentNum: orderCurrentForm.get('orderNum').value,
        orderInitialOperator: orderInitialForm.get('isEnable').value ? orderInitialForm.get('operatorType').value : 0,
        orderInitialNum: orderInitialForm.get('orderNum').value,
        stockCurrentOperator: stockCurrentForm.get('isEnable').value ? stockCurrentForm.get('operatorType').value : 0,
        stockCurrentNum: stockCurrentForm.get('stockNum').value,
        stockInitialOperator: stockInitialForm.get('isEnable').value ? stockInitialForm.get('operatorType').value : 0,
        stockInitialNum: stockInitialForm.get('stockNum').value,
        itemViewSorts: this.getItemViewSortDto(itemViewSort),
        orderBaraDisplayFlag: this.commonService?.config?.orderBaraDisplayFlag || false,
        orderStopFlagList: [],
        dateBegin: dateBegin == '' ? '' : this.commonService.formatDate(dateBegin),
        dateEnd: dateEnd == '' ? '' : this.commonService.formatDate(dateEnd),
      },
      page: {
        pageNum: this.matPagenator.pageIndex,
        dispNum: 10000
      },
      mode: mode
    }

    if (this.commonService.getOrderStopSearchCondList()?.length > 0) {
      request.itemSearchCondition.orderStopFlagList = this.getOrderStopFlagSelectedValues(orderStopFlagForm)
    }

    this.commonService.openSpinner("商品検索", "検索中・・・");
    this.subscriptionSearch = this.httpBasic.generalRequest('LimitTimeParamSearch', request).subscribe(
      (response) => {
        this.SearchResult(response)
      },
      (error) => {
        this.clearProgressState();
        this.httpBasic.handleError(error);
      }
    );
  }

  clearProgressState() {
    this.commonService.closeSpinner();
    this.subscriptionSearch.unsubscribe();
    this.subscriptionSearch = undefined;
  }

  SearchResult(response) {
    this.clearProgressState();

    if (response.fatalError && response.fatalError.length > 0) {
      this.commonService.openFatalErrorDialog("商品検索", response.fatalError[0].errMsg);
    }
    if (response.normalError && response.normalError.length > 0) {
      this.commonService.openErrorDialog("商品検索", response.normalError[0].errMsg);
      return;
    }
    this.itemList = [];
    this.settingList = [];
    this.recordCountItemList = response.limitTimeParamItem.length;
    this.recordCountSettingList = response.limitTimeParamSetting.length;
    if (this.recordCountItemList >= 10000) {
      this.commonService.openNotificationDialog(this.commonService.pageTitle, `10000件を超える商品が検索されました。最初の10000件のみが処理対象となります。`);
    }
    if (this.recordCountItemList > 0) {
      for (var row of response.limitTimeParamItem) {
        this.itemList.push(new ItemLimitTimeSearchRec(row, this.commonService));
      }
    }
    if (this.recordCountSettingList > 0) {
      for (var row of response.limitTimeParamSetting) {
        this.settingList.push(new ItemLimitTimeRec(row, this.commonService));
      }
    }
    if (this.matPagenator) {
      this.matPagenator.pageIndex = this.commonService.paginatorOption.pageSizeIndex;
      this.matPagenator.pageSize = this.commonService.config?.pagenatorOptions[0];
    }
    if (this.matPagenatorLimit) {
      this.matPagenatorLimit.pageIndex = this.commonService.paginatorOption.pageSizeIndex;
      this.matPagenatorLimit.pageSize = this.commonService.config?.pagenatorOptions[0];
    }
    this.itemListOrigin = this.itemList?.length > 0 ? [...this.itemList].map(rec => new ItemLimitTimeSearchRec(rec?.originDto, this.commonService)) : [];
    //this.settingListOrigin = this.settingList?.length > 0 ? [...this.settingList].map(rec => new ItemLimitTimeRec(rec?.originDto, this.commonService)) : [];
    this.itemListPageChanged();
    this.settingListPageChanged();
  }

  getOrderStopFlagSelectedValues(orderStopFlagFormGroup: FormGroup): number[] {
    const orderStopFlagList = [...this.commonService.getOrderStopSearchCondList()];
    if (orderStopFlagList?.length <= 0) return [];
    const selectedList: number[] = orderStopFlagList.filter(orderStopFlagItem => {
      return orderStopFlagFormGroup.get(`orderStopFlagItem_${orderStopFlagItem.value}`)?.value === true
    }).map(orderStopFlagItem => orderStopFlagItem?.value);
    return selectedList;
  }

  getItemViewSortDto(itemViewSort: FormGroup): ReqItemViewSortDto[] {
    let res: ReqItemViewSortDto[] = [];
    if (!itemViewSort?.controls) return [];
    for (let groupName in itemViewSort.controls) {
      const fG = itemViewSort?.controls[groupName];
      const row: ReqItemViewSortDto = {
        column: groupName,
        orderType: fG.get('orderType')?.value ?? '',
        orderValue: fG.get('orderValue')?.value ? parseInt(fG.get('orderValue').value) : 0
      }
      res.push(row);
    }
    return res;
  }

  isDisable(): boolean {
    if (this.itemList == undefined || this.itemList.length == 0) return true;
    let isChange = this.itemList?.filter(item => { return this.changeCurrentOrStock(item) })
    if (isChange?.length == 0) return true;
    return false;
  }

  changeCurrentOrStock(item: ItemLimitTimeSearchRec) {
    if (item.minZaiCurrentFv != item.minZaiCurrentFvForm.value
      || item.maxZaiCurrentFv != item.maxZaiCurrentFvForm.value
      || item.minStockDaysCurrentFv != item.minStockDaysCurrentFvForm.value
      || item.maxStockDaysCurrentFv != item.maxStockDaysCurrentFvForm.value)
      return true;
    return false
  }

  onInputNum(item: ItemLimitTimeSearchRec, text, title) {
    switch (text) {
      case "minZaiCurrentFv":
        if (parseInt(item[text + 'Form'].value) < this.minZai1 || parseInt(item[text + 'Form'].value) > this.minZai2) {
          item.isDisable = true;
          this.commonService.openErrorDialog(title, title + "の範囲は [ " + this.minZai1 + " ～ " + this.minZai2 + " ] です。");
          return;
        }
        break;

      case "maxZaiCurrentFv":
        if (parseInt(item[text + 'Form'].value) < this.maxZai1 || parseInt(item[text + 'Form'].value) > this.maxZai2) {
          item.isDisable = true;
          this.commonService.openErrorDialog(title, title + "の範囲は [ " + this.maxZai1 + " ～ " + this.maxZai2 + " ] です。");
          return;
        }
        break;

      case "minStockDaysCurrentFv":
        if (parseInt(item[text + 'Form'].value) < this.minStock1 || parseInt(item[text + 'Form'].value) > this.minStock2) {
          item.isDisable = true;
          this.commonService.openErrorDialog(title, title + "の範囲は [ " + this.minStock1 + " ～ " + this.minStock2 + " ] です。");
          return;
        }
        break;

      case "maxStockDaysCurrentFv":
        if (parseInt(item[text + 'Form'].value) < this.maxStock1 || parseInt(item[text + 'Form'].value) > this.maxStock2) {
          item.isDisable = true;
          this.commonService.openErrorDialog(title, title + "の範囲は [ " + this.maxStock1 + " ～ " + this.maxStock2 + " ] です。");
          return;
        }
        break;
    }

    if (parseInt(item.minZaiCurrentFvForm.value) > parseInt(item.maxZaiCurrentFvForm.value) || parseInt(item.minStockDaysCurrentFvForm.value) > parseInt(item.maxStockDaysCurrentFvForm.value)) {
      item.isDisable = true;
      this.commonService.openErrorDialog("最低", "最低、最大が逆転しています。");
      return;
    }

    item.isDisable = false;
  }

  checkErrInput(): boolean {
    let isChange = this.itemList?.filter(item => { return this.errInput(item) });
    if (isChange?.length == 0) return true;
    return false;
  }

  errInput(item: ItemLimitTimeSearchRec) {
    if (item.isDisable == true) return true;
    return false;
  }

  handlerDate(date, event) {
    const targetValues = ["1111", "2222", "3333", "4444", "5555", "6666", "7777", "8888", "9999"];
    if (date == 'dateBegin') {
      this.minDateEnd = new Date(this.isValidDate(event.targetElement.value));
    }
    if (event.targetElement.value == "") {
      this.formGroupItem.get(date).setValue("");
      return;
    }
    if (targetValues.includes(event.targetElement.value)) {
      this.formGroupItem.get(date).setValue(new Date("2999/12/31"));
      return;
    }
    if (this.isValidDate(event.targetElement.value) == "") {
      this.commonService.openErrorDialog("期間", "正しい日付の形式で入力してください。(yymmdd、yyyymmdd、yyyy/mm/dd)");
      this.formGroupItem.get(date).setValue("");
      return;
    } else {
      this.formGroupItem.get(date).setValue(new Date(this.isValidDate(event.targetElement.value)));
    }
  }

  isValidDate(dateStr): string {
    let currentYear = new Date();
    if (dateStr.length == 6) {
      dateStr = currentYear.getFullYear().toString().substring(0, 2) + dateStr;
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6);
      dateStr = `${year}${'/'}${month}${'/'}${day}`;
    }

    if (dateStr.length == 8) {
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6);
      dateStr = `${year}${'/'}${month}${'/'}${day}`;
    }

    const regex = /^\d{4}\/(0[1-9]|1[012])\/(0[1-9]|[12]\d|3[01])$/;
    if (regex.test(dateStr)) return dateStr;
    return "";
  }

  doDelete(item: ItemLimitTimeRec) {
    let msg = "削除してよろしいですか？";
    let subsc = this.commonService.openYesNoDialog(this.commonService.pageTitle, msg).subscribe(
      (response) => {
        subsc.unsubscribe();
        if (response == true) {
          this.doDeleteBody(item);
        }
      }
    );
  }

  doDeleteBody(item: ItemLimitTimeRec) {
    let request = {
      access: this.commonService.loginUser,
      storeCdFv: item.storeCdFv,
      itemCdFv: item.itemCdFv
    }
    this.commonService.openSpinner(this.commonService.pageTitle, "更新中・・・");
    let subsc = this.httpBasic.generalRequest("LimitTimeParamDelete", request).subscribe(
      (response) => {
        subsc.unsubscribe();
        this.receiveDelete(response, item);
      },
      (error) => {
        subsc.unsubscribe();
        this.commonService.closeSpinner();
        this.httpBasic.handleError(error);
      }
    );
  }

  receiveDelete(response, deleteItem: ItemLimitTimeRec) {
    if (this.httpBasic.handleAppError(response)) {
      return;
    }
    this.commonService.closeSpinner();
    this.settingList.forEach((item, index) => {
      if (item.storeCdFv == deleteItem.storeCdFv && item.itemCdFv == deleteItem.itemCdFv) {
        this.settingList.splice(index, 1);
      }
    });
    this.settingListPageChanged();
    this.commonService.openNotificationDialog(this.commonService.pageTitle, "削除しました。");
  }

  getCsvFromTable(tagid: string) {
    if (!navigator.clipboard) return;
    let elem = document.getElementById(tagid);
    if (!elem) return;

    let csv = "";
    let line = "";

    let thElems = elem.getElementsByTagName("th");
    for (let i = 0; i < thElems.length; i++) {
      if (i > 0) line += "\t";
      line += thElems[i].textContent.trim();
    }
    line = line.replace("削除\t", "");
    csv = line + "\n";

    let tbody = elem.getElementsByTagName("tbody");
    let trElems = tbody[0].getElementsByTagName("tr");
    for (let i = 0; i < trElems.length; i++) {
      if (!trElems[i]?.className?.includes("delete-color-bg")) {
        line = "";
        let tdElems = trElems[i].getElementsByTagName("td");
        for (let j = 0; j < tdElems.length; j++) {
          if (j > 0) line += "\t";
          line += tdElems[j].textContent.trim();
        }
        line = line.replace("削除", "")
        line = line.replace("\t", "");
        csv += line + "\n";
      }
    }
    navigator.clipboard.writeText(csv);
    this.commonService.openNotificationDialog(this.commonService.pageTitle, "クリップボードにコピーしました。")
  }

  getCsvFromTableItem(tagid: string) {
    if (!navigator.clipboard) return;
    let elem = document.getElementById(tagid);
    if (!elem) return;

    let csv = "";
    let line = "";

    let thElems = elem.getElementsByTagName("th");
    for (let i = 0; i < thElems.length; i++) {
      if (i > 0) line += "\t";
      line += thElems[i].textContent.trim();
    }
    line = line.replace("削除\t", "");
    csv = line + "\n";

    let tbody = elem.getElementsByTagName("tbody");
    let trElems = tbody[0].getElementsByTagName("tr");
    for (let i = 0; i < trElems.length; i++) {
      if (!trElems[i]?.className?.includes("delete-color-bg")) {
        line = "";
        let tdElems = trElems[i].getElementsByTagName("td");
        for (let j = 0; j < tdElems.length; j++) {
          if (j > 0) line += "\t";
          line += tdElems[j].textContent.trim();
        }
        csv += line + "\n";
      }
    }
    navigator.clipboard.writeText(csv);
    this.commonService.openNotificationDialog(this.commonService.pageTitle, "クリップボードにコピーしました。")
  }

  doCancel() {
    this.itemList = this.itemListOrigin?.length > 0 ? [...this.itemListOrigin].map(rec => new ItemLimitTimeSearchRec(rec?.originDto, this.commonService)) : [];
    this.itemListPageChanged();
  }

  announceSortChange(sortState: Sort) {
    // This example uses English messages. If your application supports
    // multiple language, you would internationalize these strings.
    // Furthermore, you can customize the message to add additional
    // details about the values being sorted.
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }
}
